import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Home';
import GuideToFeatures from './blog/GuideToFeatures';
import EthicsBlog from './blog/EthicsBlog';
import './App.css';

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home variant="default" />} />
            <Route path="/features" element={<Home variant="default" />} />
            <Route path="/demo" element={<Home variant="default" />} />
            <Route path="/coding-assistant" element={<Home variant="default" />} />
            <Route path="/interview-copilot" element={<Home variant="default" />} />
            <Route path="/pricing" element={<Home variant="default" />} />
            <Route path="/testimonials" element={<Home variant="default" />} />
            <Route path="/faqs" element={<Home variant="default" />} />
            <Route path="/contact" element={<Home variant="default" />} />
            <Route path="/download" element={<Home variant="default" />} />
            <Route path="/assistant" element={<Home variant="assistant" />} />
            <Route path="/assistant/features" element={<Home variant="assistant" />} />
            <Route path="/assistant/demo" element={<Home variant="assistant" />} />
            <Route path="/assistant/coding-assistant" element={<Home variant="assistant" />} />
            <Route path="/assistant/interview-copilot" element={<Home variant="assistant" />} />
            <Route path="/assistant/pricing" element={<Home variant="assistant" />} />
            <Route path="/assistant/testimonials" element={<Home variant="assistant" />} />
            <Route path="/assistant/faqs" element={<Home variant="assistant" />} />
            <Route path="/assistant/contact" element={<Home variant="assistant" />} />
            <Route path="/assistant/download" element={<Home variant="assistant" />} />
            <Route path="/blog/guide-to-features" element={<GuideToFeatures />} />
            <Route path="/blog/ethics" element={<EthicsBlog />} />
        </Routes>
    );
}

export default App;
